import { IMG } from "@/lib/assets";
import { useAppearance, siteImg } from "@/context/AppearanceContext";

export const SiteLogo = ({ className, testid }) => {
  const { logo_main } = useAppearance();
  return <img src={siteImg(logo_main) || IMG.logo} alt="JP STORE" className={className} data-testid={testid} />;
};
